import React from 'react'
// libs
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
// themes
import { colors } from 'themes'
// icons
import VerginaSun from 'src/icons/vergina-sun.svg'

// Drop-in replacement for a MUI icon: purple by default, respects fontSize / sx overrides
const VerginaSunIcon: React.FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon component={VerginaSun} inheritViewBox sx={{ color: colors.purple300, ...sx }} {...props} />
)

export default VerginaSunIcon
